
export class AssignPropiedadPropietarioRequest {

    public id_Propiedad: number = 0;
    public id_Propietario: number = 0;
    public titular:boolean = false;
}
